import { gql } from "@apollo/client";

export const SIGN_IN = gql`
  mutation signIn($idToken: String!) {
    signIn(idToken: $idToken) {
      token
      user {
        id
        email
        name
        phoneNumber
        company
      }
    }
  }
`;

export const SIGN_UP = gql`
  mutation SignUp(
    $idToken: String!
    $name: String!
    $phoneNumber: String!
    $company: String!
  ) {
    signUp(
      idToken: $idToken
      name: $name
      phoneNumber: $phoneNumber
      company: $company
    ) {
      token
    }
  }
`;

export const UPDATE_USER_INFO = gql`
  mutation UpdateUserInfo($userId: ID!, $input: UserInfoInput!) {
    updateUserInfo(userId: $userId, input: $input) {
      id
      name
      phoneNumber
      company
    }
  }
`;
